import React, {useEffect, useState, useCallback} from 'react';
import {withRouter, useParams, Link} from 'react-router-dom';
import {useDispatch} from "react-redux";
import {Menu} from '../../utils/menu/Menu';
import {
  rolePermissionEditAction,
  rolePermissionsAction,
  permissionsAction,
  roleGetAction
} from '../../actions/rolesAction';
import {formatErrors, modulesFull} from '../../constants';
import {toast} from 'react-toastify';
import {InputCheckbox} from "../../utils/checkbox/InputCheckbox";

function RolePermission(props) {
    const {history} = props;
    const dispatch = useDispatch();
    const {id} = useParams();
    const [form, setForm] = useState(null);
    const [role, setRole] = useState(null);
    const [loading, setLoading] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [modulesItems, setModulesItems] = useState({});
    const [itemsModules, setItemsModules] = useState({});
    const [modules, setModules] = useState({});

    const getPermissions = useCallback((data) => {
      dispatch(permissionsAction()).then((res) => {
        let modulesItems = {};
        let itemsModules = {};
        let modules = {};
        let fm = {};
        const groupedPermissions = (res.list || []).reduce((acc, permission) => {
          const module = permission.module || 'N/A';
          if (module === 'N/A') {
            return acc;
          } else if (permission.permission === 'front') {
            modules[module] = {name: permission.name, id: permission.id};
            fm[permission.id] = fm[permission.id] || {};
            fm[permission.id]['front'] = data[permission.id]?.['front'] || false;
            return acc;
          }

          if (!acc[module]) {
            acc[module] = [];
          }
          acc[module].push(permission);
          return acc;
        }, {});
        setModules(modules);
        setPermissions(groupedPermissions);
        for (const [key, item] of Object.entries(groupedPermissions)) {
          for (const perm of item || []) {
            fm[perm.id] = fm[perm.id] || [];
            
            for (const p of perm.permission.split(',')) {
              fm[perm.id][p.trim()] = data[perm.id]?.[p.trim()] || false;
            }
            if (perm.module) {
              perm.module.trim().split(',').forEach(m => {
                if (m) {
                  modulesItems[m.split(':')[0]] = modulesItems[m.split(':')[0]] || [];
                  for (const p of perm.permission.split(',')) {
                    modulesItems[m.split(':')[0]].push(perm.id + ':' + p.trim());
                    if (!itemsModules[perm.id + ':' + p.trim()]) {
                      itemsModules[perm.id + ':' + p.trim()] = [];
                    }
                    if (itemsModules[perm.id + ':' + p.trim()].indexOf(m.split(':')[0]) === -1) {
                      itemsModules[perm.id + ':' + p.trim()].push(m.split(':')[0]);
                    }
                  }
                }
              });
            }
          }
        }
        setForm(fm);
        setModulesItems(modulesItems);
        setItemsModules(itemsModules);
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);

    const getRole = useCallback((id) => {
      dispatch(roleGetAction(id)).then((data) => {
        setRole(data);
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);
  
    const getPermission = useCallback((id) => {
      dispatch(rolePermissionsAction(id)).then((data) => {
        const permissions = {};
        data.forEach(item => {
          permissions[item.permission_id] = permissions[item.permission_id] || {};
          for (const p of item.permission.split(',')) {
            permissions[item.permission_id][p.trim()] = true;
          }
        });
        getPermissions(permissions);
      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    }, [dispatch]);

    const handleChangeCheckbox = (permId, name) => {
      permId = +permId;
      const value = !form[permId]?.[name];
      setForm(prev => ({
        ...prev,
        [permId]: {
          ...prev[permId],
          [name]: value
        }
      }));
      dispatch(rolePermissionEditAction({id: +id, permission: permId, name, value})).then(() => {

      }).catch(err => {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      });
    };

    const handleChangeModuleCheckbox = (permId, name) => {
      const val = !form[permId]?.['front'];
      handleChangeCheckbox(permId, 'front');

      if (modulesItems[name]) {
        modulesItems[name].forEach(item => {
          if (form[item.split(':')[0]] && form[item.split(':')[0]][item.split(':')[1]] !== val) {
            const moduleId = modules[name].id;
            let hasActive = false;
            if (!val) {
              hasActive = itemsModules[item].some(m => m !== name && form[moduleId] && form[moduleId]['front']);
            }
            if (!hasActive) {
              handleChangeCheckbox(item.split(':')[0], item.split(':')[1]);
            } else {
              console.log('hasActive', item);
            }
          }
        });
      }
    }

    useEffect(() => {
      if (!id || id === '0') {
        history.push('/roles');
        return;
      }
      getRole(id);
      getPermission(id);
    }, [id, getPermission, getPermissions]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/roles'} className="header__link">Роли</Link>
    </header>

    {permissions && form && <div className="profile">
      <form className="profile__wrapper" noValidate>
        <span className="profile__heading">Роль</span>
        {role && <h4 className="profile__name">{role.name}</h4>}
        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <div style={{textAlign: 'left', marginTop: 20}}>
              <p className="help"><b>Модули</b></p>
              <small>Список модулей не связан напрямую с разрешениями. При установке активности модуля, разрешения на него не устанавливаются автоматически. 
                При снятии активности модуля, если разрешение используется в другом модуле, оно не снимается.
              </small>
              <br />
              {Object.entries(modules).map(([key, item]) => (
                <div key={key} style={{marginLeft: 20}}>
                  <InputCheckbox title={item.name} name={'mm_'+key} checked={form[item.id] && form[item.id]['front']} onChange={() => handleChangeModuleCheckbox(item.id, key)} />
                </div>
              ))}

              <br /><br />
              <p className="help"><b>Разрешения - полный список по модулям</b></p>
              <div>
                {Object.entries(permissions).map(([key, item]) => (
                  <div key={key}>
                    <h4 style={{marginBottom: 10, marginTop: 20}}>{key.split(',').map(k => modulesFull[k] || k).join(', ')}</h4>
                    {item && item.map((perm, index) => (
                      <div key={index} style={{marginLeft: 20}}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                          <div style={{marginRight: 20, maxWidth: '300px', width: '300px', float: 'left', fontSize: '13px', paddingBottom: 5}}>{perm.name} <div><small>{perm.route_path}</small></div></div>
                          {perm.permission.split(',').map(p => (
                            <div key={"prm_" + perm.id + "_" + p}  style={{float: 'left', marginLeft: '20px'}}><InputCheckbox 
                              key={"cb_" + perm.id + "_" + p}
                              title={p.trim() === 'read' ? 'Чтение' :
                                p.trim() === 'update' ? 'Запись' : 
                                p.trim() === 'delete' ? 'Удаление' : 
                                p.trim()}
                              name={p.trim()}
                              checked={form[perm.id] && form[perm.id][p.trim()]}
                              onChange={() => handleChangeCheckbox(perm.id, p.trim())}
                              style={{marginRight: 20}} // Increased padding between checkboxes from 10 to 20
                            /></div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
                
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>}
  </div>;
};

export default withRouter(RolePermission);
